'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils2 = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresAccommodationPackage = function () {
    function WinresAccommodationPackage($scope, $window, reservationService, productService, localizationService, cancelService, urlService) {
        _classCallCheck(this, WinresAccommodationPackage);

        this.$scope = $scope;
        this.$window = $window;
        this.reservationService = reservationService;
        this.productService = productService;
        this.localizationService = localizationService;
        this.cancelService = cancelService;
        this.urlService = urlService;
        this.package = null;
        this.linkedProducts = [];
        this.$scope.moment = _moment2.default;

        // If this is a package, its price is stored here.
        this.packagePrice = invalidPackagePrice('.');
        this.selectedPrice = null;
    }

    _createClass(WinresAccommodationPackage, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().Passengers
            // calculateTotalPrice
            // Params

            // Set:
            // getContext().PriceGroup
            // getContext().Products

            var wrc = this.winresReservationContext;
            this.data = this.winresReservationContext.getContext();

            this.initDateRange();

            this.$scope.$watch(function () {
                return _this.data.Destination;
            }, function (destination) {
                if (destination && destination.DestinationCode !== _this.currentDestinationCode) {
                    _this.fetchProducts(destination.DestinationCode, wrc.getUrlParams().ProductCode);
                    _this.currentDestinationCode = destination.DestinationCode;
                }
            });

            this.$scope.$watch(function () {
                return _this.selectedPrice;
            }, function () {
                if (_this.selectedPrice != null) {
                    _this.updatePackagePrice();
                }
            });
        }
    }, {
        key: 'addPassengerAmountsToUrl',
        value: function addPassengerAmountsToUrl() {
            var numOfPassengers = this.numOfAdultsAndChildrenByIndex(this.selectedPrice.Index);

            var numAdults = numOfPassengers.numAdults;
            var numChildren = numOfPassengers.numChildren;
            var numInfants = this.data.NumInfants;

            var urlParams = this.winresReservationContext.getUrlParams();

            // Change numAdults, numChildren and numInfants in url.
            this.urlService.setParamsToUrl({
                dn: urlParams.DestinationName,
                dc: urlParams.DestinationCode,
                pc: urlParams.ProductCode,
                bd: urlParams.StartDate,
                ed: urlParams.EndDate,
                na: numAdults,
                nc: numChildren,
                ni: numInfants
            }, false);

            // Update url params in context.
            this.winresReservationContext.initUrlData();

            // Context still has passenger amounts from previous url, change passenger amounts correctly.
            this.winresReservationContext.Params.NumAdult = numAdults;
            this.winresReservationContext.Params.NumChildren = numChildren;
            this.winresReservationContext.Params.NumInfants = numInfants;

            // Update passengers.
            this.winresReservationContext.initPassengerFieldsBase();
            this.winresReservationContext.initPassengers();
        }
    }, {
        key: 'initDateRange',
        value: function initDateRange() {
            this.daterangeDates = [];

            var wrc = this.winresReservationContext;
            this.daterange = {
                startDate: (0, _moment2.default)(wrc.Params.StartDate),
                endDate: (0, _moment2.default)(wrc.Params.StartDate)
            };
        }
    }, {
        key: 'fetchProducts',
        value: function fetchProducts(destinationCode, productCode) {
            var _this2 = this;

            var request = this.getReservableProducts({ DestinationCode: destinationCode,
                ProductCode: productCode });
            this.loadingPromise = request;

            request.then(function (products) {
                if (products.length > 0) {
                    _this2.updateCalendar(products[0]);
                }
            });
        }
    }, {
        key: 'getReservableProducts',
        value: function getReservableProducts(params) {
            params.MinCapacity = 1;
            return this.productService.getReservableProducts(params, this.localizationService.getLanguage());
        }
    }, {
        key: 'updateCalendar',
        value: function updateCalendar(product) {
            var _this3 = this;

            var request = this.productService.getCapacityCalendar(product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, true);
            this.loadingPromise = request;

            request.then(function (capacity) {
                if (capacity) {
                    _this3.showCalendar = true;
                    _this3.daterangeDates = capacity;

                    _this3.update();
                    _this3.watchCalendar();
                }
            });
        }
    }, {
        key: 'watchCalendar',
        value: function watchCalendar() {
            var _this4 = this;

            if (this.dateWatch) {
                // Cancel watch
                this.dateWatch();
            }

            var wrc = this.winresReservationContext;

            this.dateWatch = this.$scope.$watchGroup([function () {
                return wrc.Params.DestinationCode;
            }, function () {
                return wrc.Params.StartDate;
            }, function () {
                return wrc.Params.EndDate;
            }, function () {
                return _this4.daterange;
            }], function () {
                _this4.update();
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var wrc = this.winresReservationContext;

            // Calendar date is untouched
            if (this.daterange.startDate) {
                var startDate = wrc.Params.StartDate;
                var endDate = wrc.Params.EndDate;
            } else {
                var startDate = (0, _utils2.formatISODate)(this.daterange);
                var endDate = (0, _utils2.formatISODate)(this.daterange.clone().add(1, 'days'));
            }

            this.loadPackage(wrc.Params.DestinationCode, startDate, endDate);
        }
    }, {
        key: 'loadPackage',
        value: function loadPackage(destCode, startDate, endDate) {
            var _this5 = this;

            this.picks = null;
            this.package = null;

            var language = this.localizationService.getLanguage();
            var request = this.productService.getAccommodationPackage(destCode, startDate, endDate, language);
            this.loadingPromise = request;

            if (this.pending) {
                this.cancelService.cancel(this.pending);
            }

            this.pending = request;

            request.then(function (pack) {
                if (!pack) {
                    // Canceled promise.
                    return;
                }

                console.log('[WAP - Loaded package]', pack);
                _this5.picks = _this5.initialPicks(pack);
                _this5.package = pack;

                _this5.selectPriceByNumOfAdultsAndChildren();
                _this5.updatePackagePrice();
            });
        }
    }, {
        key: 'selectPriceByNumOfAdultsAndChildren',
        value: function selectPriceByNumOfAdultsAndChildren() {
            var index = this.priceIndex(this.data.NumAdults, this.data.NumChildren);
            this.selectedPrice = _.find(this.package.RootProduct.ReservablePrices, function (p) {
                return p.Index == index;
            });
        }
    }, {
        key: 'addToShoppingCart',
        value: function addToShoppingCart(pack) {
            var _this6 = this;

            // The price group to use for the package root product.
            // The linked products' price groups come from the linkings.
            this.data.PriceGroup = 'NR';

            try {
                var packageIndex = this.findNextFreePackageIndex(this.data.Products);
                var rootProductLine = this.addRootProduct(packageIndex, pack.RootProduct);
                _.each(pack.ForcedProducts, function (product) {
                    console.log('[WRT - Process forced product]', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, product.BeginDate, product.EndDate);
                    _this6.addForcedProduct(packageIndex, product);
                });
                _.each(pack.GroupForcedProducts, function (group) {
                    var pickedIndex = _this6.picks.groupForced[group.Key];
                    // console.log(pickedIndex);
                    var pickedProduct = group.Value[pickedIndex];
                    // var firstProduct = group.Value[0];
                    _this6.addForcedProduct(packageIndex, pickedProduct);
                });

                // this.$scope.justAddedToCart = true;
                // this.$timeout(() => { this.$scope.justAddedToCart = false; }, 5000);
            } catch (e) {
                this.data.Products = [];
                alert(e);
            }

            //console.log('calling onAdd');
            this.onAdd({ 'window': window });
            //console.log('after calling onAdd');
        }
    }, {
        key: 'findNextFreePackageIndex',
        value: function findNextFreePackageIndex(shoppingCartProductLines) {
            // Package indexes start from 1.
            var indexes = _.map(shoppingCartProductLines, function (line) {
                return line.PackageRootIndex || 0;
            });
            var highestExisting = _.max(indexes) || 0;
            return highestExisting + 1;
        }
    }, {
        key: 'initialPicks',
        value: function initialPicks(pack) {
            return {
                groupForced: this.initialPicksForGroupForcedProducts(pack.GroupForcedProducts)
            };
        }

        // Create an object where the keys are group IDs and values are initial selections. Initial selection = first value that has capacity.
        // E.g. { '1': 0, '2': 0 }

    }, {
        key: 'initialPicksForGroupForcedProducts',
        value: function initialPicksForGroupForcedProducts(groups) {
            var picks = {};
            _.each(groups, function (group) {
                var id = 0;
                var firstProduct = group.Value[0];
                var groupID = firstProduct.LinkingInfo.GroupID;
                _.each(group.Value, function (value, index) {
                    if (value.Capacity != 0) {
                        id = index;
                        return false;
                    }
                });
                picks[groupID] = id;
            });
            // console.log(picks);
            return picks;
        }

        // calculateRootProductPrice(productLine) {
        //     productLine.TotalPrice = null;
        //     productLine.UnitPrice = null;
        //     productLine.SingleSupplement = null;
        //     this.reservationService.calculateProductLinePrice(
        //         this.data,
        //         productLine,
        //         this.localizationService.getLanguage()
        //     ).then(pricingResult => {
        //         productLine.UnitPrice = pricingResult.UnitPrice;
        //         productLine.TotalPrice = pricingResult.Price;
        //         productLine.SingleSupplement = pricingResult.SingleSupplement;
        //     });
        // }

    }, {
        key: 'addRootProduct',
        value: function addRootProduct(packageIndex, product) {
            console.log('[WAP - Add root product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.Amount = 1;
            productLine.Product.Amount = productLine.Amount;
            productLine.PackageRootIndex = packageIndex;

            var index = this.selectedPrice.Index;
            this.setPriceAmount(productLine, index, 1);

            this.winresReservationContext.calculateTotalPrice(productLine);

            return productLine;
        }
    }, {
        key: 'priceIndex',
        value: function priceIndex(adults, children) {
            if (adults < 1 || adults > 3) {
                console.error('[WAP] Accommodation packages only support 1-3 adults.');
                return null;
            }
            if (children < 0 || children > 3) {
                console.error('[WAP] Accommodation packages only support 0-3 children.');
                return null;
            }
            return 4 * (adults - 1) + children + 1;
        }
    }, {
        key: 'numOfAdultsAndChildrenByIndex',
        value: function numOfAdultsAndChildrenByIndex(index) {
            if (index == null) {
                return null;
            }

            return {
                numAdults: Math.ceil(index / 4), // +1 every 4.
                numChildren: (index - 1) % 4 // 0 1 2 3.
            };
        }
    }, {
        key: 'addForcedProduct',
        value: function addForcedProduct(packageIndex, product) {
            console.log('[WAP - Add forced product]', product);
            if (product.DestinationInfo.Accommodation) {
                this.addAccommodationProduct(packageIndex, product);
            } else {
                this.addExtraServiceProduct(packageIndex, product);
            }
        }
    }, {
        key: 'addAccommodationProduct',
        value: function addAccommodationProduct(packageIndex, product) {
            console.log('[WRT - Add accommodation product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.Amount = 1;
            productLine.Product.Amount = productLine.Amount;
            productLine.PackageMemberIndex = packageIndex;
            productLine.PriceGroup = product.LinkingInfo.LinkedPriceGroup;
            productLine.PriceIncludedInPackage = true;
            productLine.UnitPrice = 0;
            productLine.TotalPrice = 0;
            this.assignAllPassengersToAccommodation(productLine);
            // Success not currently checked
        }
    }, {
        key: 'addExtraServiceProduct',
        value: function addExtraServiceProduct(packageIndex, product) {
            console.log('[WRT - Add extra service product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.PriceGroup = product.LinkingInfo.LinkedPriceGroup;
            productLine.PackageMemberIndex = packageIndex;
            productLine.PriceIncludedInPackage = true;
            productLine.UnitPrice = 0;
            productLine.TotalPrice = 0;

            var reservableIndexes = (product.ReservablePrices || []).map(function (x) {
                return x.Index;
            });

            var linkedIndexes = product.LinkingInfo.PriceIndexes || [];
            if (linkedIndexes.length > 0) {
                // All fine.
            } else {
                // Assume all are linked, since we don't have this information for some reason.
                linkedIndexes = reservableIndexes.slice();
                console.warn('[WAP] Service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'should have at least one linked price index. Defaulting to:', linkedIndexes);
            }

            var indexes = _.intersection(reservableIndexes, linkedIndexes);

            if (product.LinkingInfo.IsForEachPassenger) {
                var ADULT = 1;
                var CHILD = 2;
                var ad = this.data.NumAdults;
                var ch = this.data.NumChildren;
                if (indexes.length == 2 && indexes[0] == ADULT && indexes[1] == CHILD) {
                    console.log('[WAP] Adding per-passenger service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'for', ad, 'adults (price index 1) and', ch, 'children (price index 2).');
                    this.setPriceAmount(productLine, ADULT, ad);
                    this.setPriceAmount(productLine, CHILD, ch);
                } else {
                    var index = indexes[0];
                    var amount = ad + ch;
                    console.log('[WAP] Adding per-passenger service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'with price index', index, 'for', amount, 'passengers');
                    this.setPriceAmount(productLine, index, amount);
                }
            } else {
                var _index = indexes[0];
                console.log('[WAP] Adding per-booking service', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, 'with price index', _index + '.');
                this.setPriceAmount(productLine, _index, 1);
            }

            this.winresReservationContext.calculateTotalPrice(productLine);
        }
    }, {
        key: 'assignAllPassengersToAccommodation',
        value: function assignAllPassengersToAccommodation(productLine) {
            var info = productLine.Product.DestinationInfo;
            var count = this.data.Passengers.length;
            if (count > info.Beds + info.ExtraBeds) {
                console.error('[WAP - Assign all passengers accommodation] Not enough beds.', 'Accommodation', info.DestinationCode, '/', info.ProductCode, 'has', info.Beds, 'regular beds', 'and', info.ExtraBeds, 'extra beds.', 'There are', count, 'passengers.');
                throw 'Not enough beds.';
            }
            // Nothing complex needs to be done here. We always reserve only one room.
            // If we reserved more, we'd need to take care that all rooms have adults etc.
            var roomNumber = 1; // The only room
            productLine.PassengerAssignments = [];
            for (var i = 0; i < count; ++i) {
                var assignment = {
                    ProductNumber: roomNumber,
                    PassengerNumber: i
                };
                productLine.PassengerAssignments.push(assignment);
            }
        }
    }, {
        key: 'addProductForAllPassengers',
        value: function addProductForAllPassengers(product) {
            var _this7 = this;

            var passengers = this.winresReservationContext.getPassengersForPricing(product.BeginDate);
            var passengersWithoutInfants = _.filter(passengers, function (o) {
                return o.Gender !== "IN";
            });
            _.each(passengersWithoutInfants, function (passenger, index) {
                _this7.winresReservationContext.addExtraServiceToPassenger(product, index);
            });
        }
    }, {
        key: 'setPriceAmount',
        value: function setPriceAmount(productLine, index, amount) {
            this.winresReservationContext.setPriceAmount(productLine, index, amount);
        }
    }, {
        key: 'updatePackagePrice',
        value: function updatePackagePrice() {
            this.packagePrice = this.getPackagePrice();
            console.log('[WAP] Package price updated:', this.packagePrice);
        }
    }, {
        key: 'getPackagePrice',
        value: function getPackagePrice() {
            if (!this.package) {
                console.warn('[WAP] packagePrice() called, no package loaded yet.');
                return invalidPackagePrice('(...)');
            }

            var index = this.selectedPrice.Index;
            var price = _.find(this.package.RootProduct.ReservablePrices, function (p) {
                return p.Index == index;
            });
            if (!price) {
                console.error('[WAP] Package has no price for valid amount of passengers. Expected index:', index);
                return invalidPackagePrice('(Price missing)');
            }

            return price;
        }
    }, {
        key: 'getDate',
        value: function getDate(product) {
            if (!product.DestinationInfo.Accommodation) {
                return (0, _utils2.formatFinnishDatePretty)(product.BeginDate);
            }
            return (0, _utils2.formatDateRange)(product.BeginDate, product.EndDate);
        }
    }]);

    return WinresAccommodationPackage;
}();

function invalidPackagePrice(label) {
    return { Index: 0, Label: label, Price: 0 };
}

WinresAccommodationPackage.$inject = ['$scope', '$window', 'reservationService', 'productService', 'localizationService', 'cancelService', 'urlService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresAccommodationPackage';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresAccommodationPackage', require('./winresAccommodationPackage.html'));
}]);

_module3.default.component('winresAccommodationPackage', {
    templateUrl: getTemplate,
    controller: WinresAccommodationPackage,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        // Scope has window. thus, window.$('.shopping-cart').show() works in on-add.
        onAdd: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresAccommodationPackage/winresAccommodationPackage.js
// module id = 445
// module chunks = 2